import Header from 'components/Header/Header';
import Overview from 'components/Overview/Overview';
import { AppContext } from 'contexts/AppContext';
import React, { useContext, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { prefetchDefaultJobsFirstPage } from 'utils/jobsQueryCache';

export default function OverviewPage() {
  const { clusterName, sortBy, sortOrder } = useContext(AppContext);

  useEffect(() => {
    if (!clusterName) return;

    void prefetchDefaultJobsFirstPage({ clusterName, sortBy, sortOrder }).catch(
      () => {}
    );
  }, [clusterName, sortBy, sortOrder]);

  return (
    <>
      <Header>
        <FormattedMessage
          id="header.overviewOfCluster"
          values={{ clusterName }}
        />
      </Header>
      <Overview />
    </>
  );
}
